export enum ELocale {
  localStorageKey = "language",
}
